import { Box, styled } from "@mui/material";

import { colors as brandColors } from "@/Components/v2/utils/brand-colors";

import { colours } from "../theme/ThemeProvider/theme";

export const UserChatBubble = styled(Box)(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark" ? colours.coreHoverStateDark : colours.coreHoverStateLight,
  padding: theme.spacing(1.5),
  borderRadius: theme.spacing(1.5),
  fontSize: theme.typography.body1.fontSize,
  position: "relative",
}));

export const MaiteAgentChatBubble = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1.5, 0),
  fontSize: theme.typography.body1.fontSize,
}));

export const ErrorMaiteAgentChatBubble = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1.5),
  fontSize: theme.typography.body1.fontSize,
  color: "black",
  borderRadius: theme.spacing(1.5),
  backgroundColor: brandColors.errorLight,
}));
